import { render } from "./Welcome.vue?vue&type=template&id=50950526&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=50950526&scoped=true&lang=css"

import exportComponent from "D:\\others\\ysj\\leer\\wisdom\\html\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50950526"]])

export default __exports__